import { Parameter } from '@angular/fire/compat/remote-config';
import { PartiallyInitializableModel } from '@sc/portal.fe.lib.app-components';


export class FeatureToggle extends PartiallyInitializableModel<FeatureToggle> {
  value?;
  id: string;
  name?: string;


  static fromParameter(parameter: Parameter): FeatureToggle {
    const answer = new FeatureToggle({ id: parameter.key });
    answer.name = parameter.key;
    try {
      answer.value = JSON.parse(parameter._value);
    } catch {
      answer.value = false;
    }
    return answer;
  }

  static featureObjectToParameters(featureObject: Record<string, any>): Parameter[] {
    return Object.entries(featureObject).map(([key, value]) => ({
      ...value,
      key,
    }));
  }

  enabledForUsername(username: string) {
    return this.value instanceof Array && !!username
      ? !!this.value.find(
          (user) => `${user}`.toLowerCase() === `${username}`.toLowerCase(),
        )
      : this.value === true;
  }
}